import Vue from "vue";
import Router from "vue-router";
import main from "@/pages/main";
import contact from "@/pages/contact";
import alarm from "@/pages/alarm";
import ebms from "@/pages/ebms";
import robot from "@/pages/robot"


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "",
      component: main,
      redirect: "/main"
    },
    {
      path: "/main",
      name: "main",
      component: main
    },
    {
      path: "/alarm",
      name: "alarm",
      component: alarm
    },
    {
      path: "/ebms",
      name: "ebms",
      component: ebms
    },
    {
      path: "/contact",
      name: "contact",
      component: contact
    },
    {
      path: "/robot",
      name: "robot",
      component: robot
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js